import React, { useEffect, useCallback, useState, useRef } from 'react';
import FormBuilderMenuView from '../view/FormBuilderMenuView';
import { MIN_WIDTH_TO_SHOW_FULL_MENU } from '../../utils/Constants';

const FormBuilderMenuEngine = React.memo(
  ({
    currentStage,
    setCurrentStage,
    sharingType,
    currentFolder,
    ...collapsableMenuProps
  }) => {
    const [isResizeBtnHidden, setIsResizeBtnHidden] = useState(false);
    const menuRef = useRef(null);

    const startMenuCollapsed = window.innerWidth < MIN_WIDTH_TO_SHOW_FULL_MENU;

    const handleResize = useCallback(() => {
      if (!menuRef.current) {
        return;
      }

      if (window.innerWidth < MIN_WIDTH_TO_SHOW_FULL_MENU) {
        menuRef.current.setIsExpanded(false);
        setIsResizeBtnHidden(true);
      } else {
        setIsResizeBtnHidden(false);
      }
    }, []);

    useEffect(() => {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const viewProps = {
      currentStage,
      setCurrentStage,
      menuRef,
      isResizeBtnHidden,
      sharingType,
      currentFolder,
      collapsableMenuProps: { initCollapsed: startMenuCollapsed, ...collapsableMenuProps }
    };

    return <FormBuilderMenuView {...viewProps} />;
  }
);

export default FormBuilderMenuEngine;
